const MODULE = 'USER';

export const USER_ID = 'USER_ID';

export const REDUCER_KEY = 'userReducer';
export const GET_USER_ID = `${MODULE}_GET_${USER_ID}`;
